export const filterPermission = (str) => {
    let info = vm.$store.state.my;
    if (!info) window.location.href = '/admin/login';
    if (info.isSuperAdmin) return true;

    let result = false;
    let limits = vm.$store.state.my.permissions;
    let array = limits.map((val, key) => {
        return val.permissionNames;
    });
    array = (array + '').split(',');
    array = Array.from(new Set(array));

    if (array.includes(str)) return result = true;
};
